import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { BottomNavigation, BottomNavigationAction, Icon } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function useWindowSize() {
	const isClient = typeof window === 'object'

	function getSize() {
		return {
			width: isClient ? window.innerWidth : undefined,
			height: isClient ? window.innerHeight : undefined
		}
	}

	const [windowSize, setWindowSize] = useState(getSize)

	useEffect(() => {
		if (!isClient) {
			return false
		}

		function handleResize() {
			setWindowSize(getSize())
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, []) // Empty array ensures that effect is only run on mount and unmount

	return windowSize
}

function BottomBar({ classes, toggleCategoriesOpen }) {
	const navigate = useNavigate()
	const shop = useSelector(state => state.shop)
	const isCatalogue = Number(shop.profiles.ueby_catalogue_only)
	const size = useWindowSize()

	const gotoShop = () => {
		if (shop.profiles.ueby_categories_display_mode == 1) {
			toggleCategoriesOpen(true)
		} else {
			gotoPage('/shop')
		}
	}

	const gotoPage = (page) => {
		navigate(page)
	}

	return (<React.Fragment>
		{(!size || size.height > 420) && <BottomNavigation
			showLabels
			sx = {(theme) => ({
				position: 'fixed',
				bottom: 0,
				width: '100%',
				backgroundColor: theme.palette.primary.main,
				'& *': {
					color: theme.palette.getContrastText(theme.palette.primary.main),
				}
			})}
		>
			<BottomNavigationAction label="Home" icon={<Icon>home</Icon>} onClick={() => gotoPage('/')} />
			{shop.shop_mode_enabled == '1' && <BottomNavigationAction label={isCatalogue ? 'Catalogo' : 'Negozio'} icon={<Icon>store_mall_directory</Icon>} onClick={() => gotoPage('/shop')} />}
			{shop.reservation_mode_enabled == '1' && <BottomNavigationAction label='Prenotazione' icon={<Icon>event_available</Icon>} onClick={() => gotoPage('/reservations')} />}
			<BottomNavigationAction label="Informazioni" icon={<Icon>info</Icon>} onClick={() => gotoPage('/negozio')} />
		</BottomNavigation>}
	</React.Fragment>)
}

export default withStyles(style)(BottomBar)
